export const compareTypeMap = {
  number: 'number',
  currency: 'number',
  currency_conversion: 'number',
  date: 'date',
  text: 'text',
  long_text: 'text',
  link: 'text',
  email_address: 'text',
  yes_no: 'yes_no',
  dropdown: 'exact',
  multiple_choice: 'multiple_choice',
  phone: 'text',
  confirmation: 'confirmation',
  lookup: 'text',
  user_lookup: 'text',
  status: 'multiple_choice',
  score: 'number',
  thirdfort: 'text' /* so these can show as disabled with subfields visible */,
  worldcheck: 'text',
  worldcheck_org: 'text',
  credas: 'text',
  credas_out_of_scope: 'text'
};

export const conditionDisabled = [
  'currency_conversion',
  'credas',
  'credas_out_of_scope',
  'thirdfort',
  'worldcheck',
  'worldcheck_org'
];
